import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { orderBy } from 'lodash-es';

@Pipe({
    name: 'appOrderBy'
})
export class AppOrderByPipe implements PipeTransform {
    transform<T>(value: T[], fields: string[], orders?: (boolean | 'asc' | 'desc')[]): T[] {
        return orderBy(value, fields, orders);
    }
}
